export const SET_PRODUCT_SETTINGS_DATA_LOADING = "SET_PRODUCT_SETTINGS_DATA_LOADING";
export const SET_PRODUCT_SETTINGS_DATA = "SET_PRODUCT_SETTINGS_DATA";
export const CLEAR_PRODUCT_SETTINGS_DATA = "CLEAR_PRODUCT_SETTINGS_DATA";